import React from "react";
import DashboardCardItem from "./DashboardCardItem";
import DashboardListItem from "./DashboardListItem";
import { sortByDate } from "../../../Utils";

import { Grid, useTheme } from "@mui/material";

const useStyles = (theme) => ({
    card: {
        borderRadius: 0,
    },
    deviceId: {
        fontSize: ".9rem",
        fontWeight: "700",
        marginBottom: ".5rem",
        textDecoration: "none",
        color: "#1976d2",
        "&:visited": {
            color: "#1976d2",
        },
        [theme.breakpoints.down('xl')]: {
            fontSize: ".8rem",
        },
    },
    onIndicator: {
        minWidth: "24px",
        minHeight: "24px",
        width: "24px",
        height: "24px",
        backgroundColor: "#ABFF00",
        borderRadius: "50%",
        boxShadow: "rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89FF00 0 2px 12px",
    },
    issueIndicator: {
        width: "24px",
        height: "24px",
        minWidth: "24px",
        minHeight: "24px",
        backgroundColor: "#FFFF00",
        borderRadius: "50%",
        boxShadow: "rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 12px",
    },
    offIndicator: {
        width: "24px",
        height: "24px",
        minWidth: "24px",
        minHeight: "24px",
        backgroundColor: "#F00",
        borderRadius: "50%",
        boxShadow: "rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px, rgba(255, 0, 0, 0.5) 0 2px 12px",
    },
    cardView: {
        "&:hover": {
            cursor: "pointer",
            color: "#1976d2",
        },
    },
    dashboardCardContainer: {
        marginBottom: "3rem",
    },
});

const deviceTypes = {
    1: "v3",
    2: "rtu",
    3: "polaris",
};

export default function DashboardCardItems({
    messages,
    typeIds,
    value,
    rowSize,
    findTimeDifference,
    getChartOverides,
    lineType,
    fields,
    layout,
}) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const timestampFields = ["dttm", "received_timestamp", "dttm"];
    const timestamp = timestampFields[value];
    const deviceType = deviceTypes[value + 1];

    return (
        <Grid container spacing={2} margin={8} sx={classes.dashboardCardContainer}>
            {messages?.[0]?.[0] && Object.prototype.hasOwnProperty.call(messages[0][0], typeIds[value]) &&
                messages?.map((d) => {
                    let sortedMessages = sortByDate(d, timestamp);

                    let indicatorColor = classes.onIndicator;
                    let deviceId = sortedMessages.find((ele) => ele[typeIds[value]])?.[typeIds[value]];
                    let thresholdMinutes = sortedMessages.find((ele) => ele.threshold_minutes)?.threshold_minutes;
                    let lastMessage = sortedMessages[sortedMessages.length - 1];
                    let lastMessageDttm = lastMessage ? lastMessage[timestamp] : "";
                    let timeDifference;
                    let siteName = "";

                    if (sortedMessages[0].short_name) {
                        siteName = sortedMessages[0].short_name?.replace("EMF", "V3");
                    } else if (sortedMessages[0].site_group_names) {
                        siteName = sortedMessages[0].site_group_names;
                    }

                    // RTU & Polaris do not have threshold minutes yet so indicator is meaningless
                    if (lastMessageDttm) {
                        timeDifference = findTimeDifference(lastMessageDttm);

                        if (timeDifference > thresholdMinutes) {
                            indicatorColor = classes.offIndicator;
                        } else if (timeDifference > 30) {
                            indicatorColor = classes.issueIndicator;
                        }
                    }

                    if (layout === "list") {
                        return (
                            <DashboardListItem
                                d={sortedMessages}
                                fields={fields}
                                value={value}
                                lineType={lineType}
                                deviceId={deviceId}
                                siteName={siteName}
                                indicatorColor={indicatorColor}
                                key={deviceId}
                                deviceType={deviceType}
                            />
                        );
                    } else if (layout === "card") {
                        return (
                            <DashboardCardItem
                                d={sortedMessages}
                                deviceId={deviceId}
                                siteName={siteName}
                                indicatorColor={indicatorColor}
                                fields={fields}
                                value={value}
                                lineType={lineType}
                                rowSize={rowSize}
                                getChartOverides={getChartOverides}
                                key={deviceId}
                                deviceType={deviceType}
                            />
                        );
                    }

                    return null;
                })}
        </Grid>
    );
}
